import { mapState } from "vuex";

export const computed = {
  ...mapState("gerencial", ["controlador"])
}
